import { useEffect, useState, useCallback } from "react";

let scriptReady = false;
let scriptLoading = false;
let scriptCallbacks = [];

function loadVimeoScript(onReady) {
  if (scriptReady) {
    onReady();
    return;
  }

  if (scriptLoading) {
    scriptCallbacks.push(onReady);
    return;
  }

  scriptLoading = true;

  const script = document.createElement("script");
  script.id = "vimeo-script";
  script.src = "https://player.vimeo.com/api/player.js";
  script.async = true;

  script.onload = () => {
    scriptReady = true;
    scriptLoading = false;
    onReady();
    scriptCallbacks.forEach((cb) => cb());
    scriptCallbacks = [];
  };

  document.body.appendChild(script);
}

export function useVimeoPlayer(videoId, options = {}) {
  const [ready, setReady] = useState(scriptReady);
  const [isLoading, setIsLoading] = useState(true);
  const [player, setPlayer] = useState(null);

  useEffect(() => {
    if (!ready) {
      loadVimeoScript(() => setReady(true));
    }
  }, [ready]);

  const callbackRef = useCallback(
    (node) => {
      if (!node || !ready) return;

      const newPlayer = new window.Vimeo.Player(node, {
        id: videoId,
        width: 640,
        ...options,
      });

      newPlayer.on("loaded", () => setIsLoading(false));

      setPlayer(newPlayer);
    },
    [ready, videoId, options]
  );

  return { callbackRef, player, isLoading };
}
